module.exports = __webpack_public_path__ + "static/media/激光切割NB-IoT气象站（带屏幕）.028d04fe.png";